import { Reveal, SectionHead } from "@/components/Reveal";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = ({ limit }) => {
  const faqs = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section className="border-y border-white/5 bg-[#0c1319] py-24 md:py-36" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10">
        <SectionHead nr="10" overline="Veelgestelde vragen" title="Antwoorden op de belangrijkste vragen" />
        <Reveal delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="grid gap-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={`faq-${i}`}
                className="rounded-xl border border-white/10 bg-[#10232F]/40 px-6 data-[state=open]:border-[#2B9FD7]/40"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-left font-heading text-sm font-semibold text-[#F5F7F9] hover:no-underline sm:text-base">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-[#CBD3D9]/85">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
